(function() {
  const teamWrapper = document.getElementById('team');

  // ソート処理
  // -----------------------------------------------------------
  let sortButtons = teamWrapper.querySelectorAll('a[data-sort-number]');
  let sortTargets = teamWrapper.querySelectorAll('.list_section');

  g_Arr(sortButtons).forEach(function(elem) {
    elem.addEventListener('click', function() {
      let sortNum = this.getAttribute('data-sort-number');
      // 一旦全て非表示
      g_Arr(sortTargets).forEach(function(target) {
        target.style.display = 'none';
      });

      if(sortNum == 0) {
        // 全て表示
        g_Arr(sortTargets).forEach(function(target) {
          target.style.display = '';
        });
      } else {
        // クリックしたカテゴリのみ表示
        document.getElementById('team___contents_display_number_' + sortNum).style.display = '';
      }
    });
  });
})();